module.exports = __webpack_public_path__ + "img/shipo-icon-double-arrow-down.aba4ff4d.svg";